import { trpc } from '@/shared/api';

/** 스토어 카테고리 트리(categories.tree) — 스토어 목록 카테고리 탭용. */
export const useCategoryTreeQuery = () => trpc.categories.tree.useQuery();
